import twilio from 'twilio-video';
import { ChatMessage } from "@/store/features/chat/types";
import { ParticipantSid } from "@/store/features/room/types";
import { User } from '@/store/features/user/types';

export type LocalTrack = twilio.LocalTrack;
export type RemoteTrack = twilio.RemoteTrack;
export type LocalDataTrack = twilio.LocalDataTrack;
export type LocalAudioTrack = twilio.LocalAudioTrack;
export type LocalVideoTrack = twilio.LocalVideoTrack;
export type RemoteVideoTrack = twilio.RemoteVideoTrack;
export type RemoteParticipant = twilio.RemoteParticipant;

export enum DataTrackMessageType {
  chat = '1',
  userData = '2',
}

export type DataTrackChatMessage = {
  type: DataTrackMessageType.chat;
  data: ChatMessage;
}

export type DataTrackUserDataMessage = {
  type: DataTrackMessageType.userData;
  data: User & {
    sender: ParticipantSid;
  };
}

export type DataTrackMessage = DataTrackChatMessage | DataTrackUserDataMessage;

export type AttachRemoteTrackParams = {
  sid: ParticipantSid;
  track: RemoteTrack;
  videoWrapperElement?: HTMLDivElement | null;
  audioCb?: (element: HTMLAudioElement) => void;
  dataCb?: (data: DataTrackMessage) => void;
  screenCb?: () => void;
  cb: (kind: string, enabled?: boolean) => void;
}

export type ParticipantTrackSubscribedParams = Omit<AttachRemoteTrackParams, 'track'>;
